import { createContext, useContext } from "react";

import { IRideMapActiveStation } from "./ride-map-station-popup.models";

export interface IRideMapStationPopupContextValue {
  openStationPopup: (station: IRideMapActiveStation) => void;
}

export const RideMapStationPopupContext =
  createContext<IRideMapStationPopupContextValue | null>(null);

export const useRideMapStationPopup = (): IRideMapStationPopupContextValue => {
  const context = useContext(RideMapStationPopupContext);

  if (!context) {
    throw new Error(
      "useRideMapStationPopup must be used within RideMapStationPopupContext.Provider",
    );
  }

  return context;
};
